import React from "react";

function ContactForm(props) {
  const {
    containerId = "contact-form-container",
    hideHeading = false,
    title = "Optimise Your Supply Chain",
    buttonText = "Request a Quote",
    hideDescription = false,
    description,
    hideContactInfo = false,
    bullets,
    formHeading = "Get in Touch",
    formSubtext = "Fill in your details and our team will reach out shortly.",
  } = props;

  React.useEffect(() => {
    window.hbspt.forms.create({
      portalId: "48416295",
      formId: "c827c244-d1af-4a9b-a879-05b1a7e666b0",
      target: `#${containerId}`,
      onFormReady: function ($form) {
        const formElement = $form.get(0);

        const interval = setInterval(() => {
          const badge = formElement.querySelector(".hs_recaptcha");
          if (badge) {
            badge.style.display = "none";
            clearInterval(interval);
          }
        }, 500);
      },
      onFormSubmitted: () => {
        window.location.href = "/thankyou";
      },
    });
  }, [containerId, buttonText]);

  const defaultDescription =
    "Choose Prozo as your supply chain partner and experience the difference that operational excellence, technological integration, and a client-centric approach can make. Let us help you unlock the full potential of your supply chain and drive your business forward.";

  return (
    <div className="pz-contact-section">
      {/* Left Column - Info */}
      <div className="pz-contact-info" hidden={hideHeading}>
        <h3 className="pz-contact-title">{title}</h3>

        {!hideDescription && (
          <p className="pz-contact-description">
            {description || defaultDescription}
          </p>
        )}

        {/* Bullet list (landing pages) or trust signals (default) */}
        {bullets ? (
          <ul className="pz-contact-bullets">
            {bullets.map((item, i) => (
              <li key={i} className="pz-contact-bullet-item">{item}</li>
            ))}
          </ul>
        ) : null}

        {!bullets && <div className="pz-contact-trust-signals">
          <div className="pz-contact-trust-item">
            <div className="pz-contact-trust-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
              </svg>
            </div>
            <div>
              <div className="pz-contact-trust-number">50+</div>
              <div className="pz-contact-trust-label">Warehouses Pan-India</div>
            </div>
          </div>

          <div className="pz-contact-trust-item">
            <div className="pz-contact-trust-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="1" y="3" width="15" height="13" />
                <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
                <circle cx="5.5" cy="18.5" r="2.5" />
                <circle cx="18.5" cy="18.5" r="2.5" />
              </svg>
            </div>
            <div>
              <div className="pz-contact-trust-number">30+</div>
              <div className="pz-contact-trust-label">Logistics Partners</div>
            </div>
          </div>

          <div className="pz-contact-trust-item">
            <div className="pz-contact-trust-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </div>
            <div>
              <div className="pz-contact-trust-number">120+</div>
              <div className="pz-contact-trust-label">Enterprise Brands</div>
            </div>
          </div>
        </div>}

        {!hideContactInfo && (
          <>
            {/* Divider */}
            <hr className="pz-contact-divider" />

            {/* Quick Contact Info */}
            <div className="pz-contact-quick-info">
              <a href="tel:+919311847248" className="pz-contact-quick-item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                <span className="pz-contact-quick-text">+91-9311847248</span>
              </a>
              <a
                href="mailto:sales@prozo.com"
                className="pz-contact-quick-item"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <span className="pz-contact-quick-text">sales@prozo.com</span>
              </a>
            </div>
          </>
        )}
      </div>

      {/* Right Column - Form Card */}
      <div className="pz-contact-form-card">
        <h4 className="pz-contact-form-card-heading">{formHeading}</h4>
        <p className="pz-contact-form-card-subtext">{formSubtext}</p>
        <div className="pz-contact-form-wrapper" id={containerId} />
      </div>
    </div>
  );
}

export default ContactForm;
